import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

const AdminDashboard = () => {
  return (
    <div
      className="shadow-none p-2 overflow-y-auto h-[calc(100vh-65px)]"
      bkl="AdminDashboard"
    >
      <div className="flex justify-between">
        <p className="text-2xl font-semibold mb-4 text-blue-500 italic">
          Coming Soon ...
        </p>
      </div>
    </div>
  );
};

export default AdminDashboard;
